import { Injectable, signal } from "@angular/core"

@Injectable({
  providedIn: "root"
})
export class PageToolbarService {
  pageToolbarHeight = signal(0)
}
